import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ToastModule} from 'primeng/toast';
import {DataViewModule} from 'primeng/dataview';
import {TableModule} from 'primeng/table';
import {BlockUIModule} from 'primeng/blockui';
import {RouterModule} from '@angular/router';
import {InputTextModule} from 'primeng/inputtext';
import {PasswordModule} from 'primeng/password';
import {ButtonModule} from 'primeng/button';
import {CalendarModule} from 'primeng/calendar';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {InplaceModule} from 'primeng/inplace';
import {EditorModule} from 'primeng/editor';
import {SharedModule} from 'primeng/api';
import {TabMenuModule} from 'primeng/tabmenu';
import {ProgressBarModule} from 'primeng/progressbar';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import {RadioButtonModule} from 'primeng/radiobutton';
import {FileUploadModule} from 'primeng/fileupload';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {TabViewModule} from 'primeng/tabview';
import {MultiSelectModule} from 'primeng/multiselect';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TooltipModule} from 'primeng/tooltip';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {AccordionModule} from 'primeng/accordion';
import {PaginatorModule} from 'primeng/paginator';
import {DialogModule} from 'primeng/dialog';
//import {GMapModule} from 'primeng/gmap';
import {ChartModule} from 'primeng/chart';
import {PanelMenuModule} from 'primeng/panelmenu';
import {MenubarModule} from 'primeng/menubar';
import {ColorPickerModule} from 'primeng/colorpicker';
import {CarouselModule} from 'primeng/carousel';
import {SelectButtonModule} from 'primeng/selectbutton';
import {CardModule} from 'primeng/card';
import {SidebarModule} from 'primeng/sidebar';
import {ConfirmationService} from 'primeng/api';

@NgModule({
  imports: [
    CommonModule, ReactiveFormsModule, RouterModule
  ],
  exports: [
    CommonModule, FormsModule, ReactiveFormsModule, RouterModule, InputTextModule, PasswordModule, ButtonModule, CalendarModule,
    OverlayPanelModule, BreadcrumbModule, InplaceModule, EditorModule, SharedModule, TabMenuModule, ProgressBarModule,
    DropdownModule, CheckboxModule, RadioButtonModule, FileUploadModule, CalendarModule, InputTextareaModule,
    TabViewModule, MultiSelectModule, InputSwitchModule, ToastModule, ConfirmDialogModule, TooltipModule,
    AutoCompleteModule, AccordionModule, PaginatorModule, DialogModule, ChartModule, PanelMenuModule, MenubarModule,
    ColorPickerModule, CarouselModule, SelectButtonModule, CardModule, DataViewModule, TableModule, BlockUIModule,
    SidebarModule
  ],
  providers: [
    ConfirmationService
  ],
})
export class CoreModule {
}
